"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverflowToggle = void 0;
var React = __importStar(require("react"));
var react_overflow_1 = require("react-overflow");
exports.OverflowToggle = function (props) {
    var _a = __read(React.useState(false), 2), overflowed = _a[0], setOverflowed = _a[1];
    var Container = props.Container
        ? props.Container
        : function (_a) {
            var children = _a.children, style = _a.style;
            return (React.createElement("div", { style: __assign({ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }, style) }, children));
        };
    return (React.createElement(react_overflow_1.OverflowDetector, { onOverflowChange: setOverflowed, style: {
            overflow: 'hidden',
            position: 'relative',
        } },
        React.createElement("div", { style: {
                position: 'absolute',
                top: 0,
                left: 0,
            } }, overflowed ? props.children.overflow : null),
        React.createElement(Container, { style: {
                visibility: overflowed ? 'hidden' : 'visible',
            } }, props.children.default)));
};
//# sourceMappingURL=overflow-toggle.js.map